import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { TrashIcon } from "../../../../ui/icons/trash"
import Button from "../../../../ui/molecules/button"
import { GGNotificationCropDTO } from "./dataservice/dto"
import { GetAllGGNotificationCrop, GGNotificationCropDelete, resetCropCreationStatus, resetCropDeleteStatus } from "./slice"
import { Alert } from "../../../../ui/organisms/alert"
import { PopupForm } from "../../../../ui/organisms/popupForm"
import { Option1Popup } from "./popup"
import { GGCropTypeOptions, GGHarvestingTypeOptions, GGManipulationOptions, optionsFormatter } from "../../../../utils"

export function GlobalGapOpzione1() {
    const dispatch = useAppDispatch()
    const ggNotificationCropState = useAppSelector(state => state.ggNotificationCrop)
    const ggNotificationState = useAppSelector(state => state.ggNotification)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const [showAddPopup, setShowAddPopup] = useState<boolean>(false)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [cropToDelete, setCropTodelete] = useState<GGNotificationCropDTO | null>(null)

    useEffect(() => {
        dispatch(GetAllGGNotificationCrop({
            itemsPerPage: 0,
            page: 0,
            ggNotificationId: ggNotificationState.ggNotificationIdToUpdate
        }))
    }, [])

    useEffect(() => {
        if (ggNotificationCropState.cropDeleteStatus === 'successfully') {
            dispatch(resetCropDeleteStatus())
            dispatch(GetAllGGNotificationCrop({
                itemsPerPage: 0,
                page: 0,
                ggNotificationId: ggNotificationState.ggNotificationIdToUpdate
            }))
        }
    }, [ggNotificationCropState.cropDeleteStatus])

    useEffect(() => {
        if (ggNotificationCropState.cropCreationStatus === 'successfully') {
            dispatch(resetCropCreationStatus())
            dispatch(GetAllGGNotificationCrop({
                itemsPerPage: 0,
                page: 0,
                ggNotificationId: ggNotificationState.ggNotificationIdToUpdate
            }))
            setShowSuccess(true)
        }
    }, [ggNotificationCropState.cropCreationStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    return (
        <div>
            {
                (showSuccess) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <div style={{ padding: '24px' }}>
                <table id="users-table" className="w-[100%]">
                    <thead className="h-[52px] uppercase">
                        <tr>
                            <th style={{ borderTopLeftRadius: '8px' }}></th>
                            <th className="width-[130px]">Prodotto</th>
                            <th className="width-[130px]">Superficie</th>
                            <th className="width-[100px]">Periodo Raccolta</th>
                            <th className="width-[130px]">Raccolta</th>
                            <th className="width-[20%]">Tipologia Coltura</th>
                            <th className="width-[130px]">Ordine Raccolta</th>
                            <th className="width-[130px]">Manipolazione</th>
                            <th className="width-[130px]">Tipo Manipolazione</th>
                            <th className="width-[130px]">Propretà Parallela</th>
                            <th className="width-[130px]">Manipolazione subappaltata</th>
                            <th className="width-[130px]">Altre attività subappaltate</th>
                            <th className="width-[130px]">Paese Destinazione</th>
                            <th className="width-[130px]">Numero/Descrizione SP</th>
                            <th className="width-[130px]">Indirizzo SP</th>
                            <th className="width-[130px]">Latitudine SP</th>
                            <th className="width-[130px]">Longitudine SP</th>
                            <th style={{ borderTopRightRadius: '8px', width: '40px' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            ggNotificationCropState.getAllCropResponse?.data.map((m, index) =>
                                <tr
                                    key={index}
                                    style={{
                                        color: '#4D797F',
                                        background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                    }}
                                >
                                    <td></td>
                                    <td>{m.product}</td>
                                    <td>{m.area}</td>
                                    <td>{m.harvestingPeriod}</td>
                                    <td>{m.harvestingExclusion ? 'Sì' : 'No'}</td>
                                    <td>{optionsFormatter(m.cropType!, GGCropTypeOptions)}</td>
                                    <td>{optionsFormatter(m.harvestingType!, GGHarvestingTypeOptions)}</td>
                                    <td>{m.manipulation ? 'Sì' : 'No'}</td>
                                    <td>{optionsFormatter(m.manipulationType!, GGManipulationOptions)}</td>
                                    <td>{m.parallelProperty? 'Sì' : 'No'}</td>
                                    <td>{m.subcontractedManipulation}</td>
                                    <td>{m.otherSubcontractedActivity}</td>
                                    <td>{m.destinationCountry}</td>
                                    <td>{m.description}</td>
                                    <td>{m.address}</td>
                                    <td>{m.latitude}</td>
                                    <td>{m.longitude}</td>
                                    <td>
                                        <button onClick={() => {
                                            setCropTodelete(m)
                                            setShowAlert(true)
                                        }}>
                                            <TrashIcon color="red" size={20} />
                                        </button>
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>

                <div className="mt-5" style={{ display: 'flex', justifyContent: 'flex-end', gap: '24px' }}>
                    <Button
                        variant="outline"
                        color="dimgrey"
                        size="md"
                        iconPosition="off"
                        label="Aggiungi"
                        onClick={() => setShowAddPopup(true)}
                    />
                </div>
            </div>
            {
                (showAlert && cropToDelete) && (
                    <Alert title="Conferma operazione" close={() => setShowAlert(false)}>
                        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                            <div className="pb-3">
                                <div>
                                    Sei sicuro di voler eliminare la seguente coltura?
                                </div>
                                <div className="mt-3 font-bold">
                                    {`${cropToDelete.product} - ${cropToDelete.area}`}
                                </div>
                            </div>
                            <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Button
                                    variant="outline"
                                    color="dimgrey"
                                    iconPosition="off"
                                    label="Annulla"
                                    size="md"
                                    onClick={() => setShowAlert(false)}
                                />
                                <div className="pl-8">
                                    <Button
                                        variant="solid"
                                        color="orange"
                                        iconPosition="off"
                                        label="Elimina"
                                        size="md"
                                        onClick={() => {
                                            dispatch(GGNotificationCropDelete(cropToDelete.id!))
                                            setShowAlert(false)
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    </Alert>
                )
            }
            {
                showAddPopup &&
                <PopupForm title={`Aggiungi coltura`} headerGreen close={() => setShowAddPopup(false)}>
                    <Option1Popup close={() => setShowAddPopup(false)}></Option1Popup>
                </PopupForm>
            }
        </div>
    )
}